import { useState } from "react";
import Body from "./Body";
const PositionSetup = () => {
  const [addNewPosition, setAddPosition] = useState(false);
  const [addNewSalarySlab, setAddNewSalarySlab] = useState(false);

  const [salarySlabData, setSalarySlabData] = useState([
    {
      slabNo: 1,
      grade: "AA",
      position: ["President", "Secretary"],
      yearlyCtc: "500000",
      monthlySalary: "23000",
      deducation: [
        { amount: "4000", cause: "Provisional fund" },
        { amount: "4000", cause: "Health insurance" },
        { amount: "4000", cause: "Government taxation" },
      ],
      grossSalary: "23000",
    },
    {
      slabNo: 2,
      grade: "BB",
      position: ["Treasurer", "Member"],
      yearlyCtc: "350000",
      monthlySalary: "18000",
      deducation: [
        { amount: "3000", cause: "Tax" },
        { amount: "2000", cause: "Medical insurance" },
      ],
      grossSalary: "18000",
    },
    {
      slabNo: 3,
      grade: "CC",
      position: ["Volunteer"],
      yearlyCtc: "250000",
      monthlySalary: "15000",
      deducation: [
        { amount: "2000", cause: "Welfare deduction" },
        { amount: "1000", cause: "Social security" },
      ],
      grossSalary: "15000",
    },
  ]);
  const handelEditSalarySlab = (data) => {
    console.log("edit output");
    setSalarySlabData((prevSlabs) =>
      prevSlabs.map((slab) =>
        slab.slabNo === data.slabNo ? { ...slab, ...data } : slab
      )
    );
  };
  const handelAddNewSalarySlab = (data) => {
    console.log("added", data);
  };

  const handelUpdatePositionList = (data) => {
    const finaloutput = data?.positionNames?.filter((val) => val !== "");
    console.log(finaloutput);
  };
  const [roleData, setRoleData] = useState([
    { id: 1, role: "Clerk", color: "#b7aefa" }, // Light purple
    { id: 2, role: "Transport coordinator (TC)", color: "#8debdc" }, // Teal/mint green
    { id: 3, role: "Lab assistant", color: "#f6b5cc" }, // Pink
    { id: 4, role: "Librarian", color: "#f6cd82" }, // Light orange/yellow
    { id: 5, role: "Organizational Event Manager (OEM)", color: "#b9c37a" }, // Olive green
    { id: 6, role: "Head of the Department (HOD)", color: "#f56866" }, // Red
  ]);
  const _this = {
    handelUpdatePositionList,
    addNewPosition,
    setAddPosition,
    addNewSalarySlab,
    setAddNewSalarySlab,
    salarySlabData,
    setSalarySlabData,
    handelEditSalarySlab,
    handelAddNewSalarySlab,
    roleData,
    setRoleData,
  };
  return <Body {..._this} />;
};

export default PositionSetup;
